import Link from "next/link";

import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { APP_SIZE, HEADER_SIZE } from "@styles/variables";
import { getOpacityColor, grayScale } from "@enkor/design/colors";
import { Z_INDEX } from "@enkor/design/variables";
import { ellipsis } from "@enkor/design/mixins/index";

export const Layout = styled.main`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* HACK: Height가 body부터 명확히 정해져 있지 않기 때문에 하위 요소에도 모두 min-height view height를 적용해주어야 컨텐츠 크기가 작을 때도 꽉 채워진 화면을 볼 수 있음. */
  min-height: 100vh;
  min-height: calc((var(--vh, 1vh) * 100));
`;

export const Header = styled.header<{ $isFixed?: boolean }>`
  position: ${({ $isFixed }) => ($isFixed ? "fixed" : "relative")};
  top: ${({ $isFixed }) => ($isFixed ? 0 : "unset")};
  left: ${({ $isFixed }) => ($isFixed ? "50%" : "unset")};
  z-index: ${Z_INDEX.NAVBAR};

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;

  transform: ${({ $isFixed }) =>
    $isFixed ? "translateX(-50%)" : "translateX(0)"};

  -webkit-backdrop-filter: ${({ $isFixed }) =>
    $isFixed ? "blur(4px)" : "unset"};

  backdrop-filter: ${({ $isFixed }) => ($isFixed ? "blur(4px)" : "unset")};
`;

export const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: ${HEADER_SIZE.HEIGHT}px;
  padding: 0 16px;

  background-color: ${getOpacityColor(grayScale[200], 0.7)};

  h1 {
    position: absolute;
    top: 50%;
    left: 50%;

    color: ${grayScale.white};

    transform: translate(-50%, -50%);
  }
`;

export const LeftButton = styled(motion.button)`
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 50%;
`;

export const LogoLink = styled(Link)`
  position: relative;

  width: 44px;
  height: 26px;
`;

export const PageTitle = styled.h1`
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;

  ${ellipsis(1)}
`;

export const RightButtonGroup = styled.div<{ $shouldStretch: boolean }>`
  position: relative;
  display: flex;
  flex: ${({ $shouldStretch }) => ($shouldStretch ? "auto" : "0")};
`;

export const ContentSection = styled.section`
  width: 100%;
  height: calc(100% - ${HEADER_SIZE.HEIGHT}px);
  /* HACK: Height가 body부터 명확히 정해져 있지 않기 때문에 하위 요소에도 모두 min-height view height를 적용해주어야 컨텐츠 크기가 작을 때도 꽉 채워진 화면을 볼 수 있음. */
  min-height: calc(100vh - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc((var(--vh, 1vh) * 100) - ${HEADER_SIZE.HEIGHT}px);
`;
